// extracted by mini-css-extract-plugin
module.exports = {"sample":"RespondentsLegend_sample__6wdF9","bullet":"RespondentsLegend_bullet__3OrNo"};